export class FormGroupOfflineResponses {
  id?: number;
  formInstanceId?: number;
  received: number;
  incomplete: number;
  receivedDate: number | Date;
}
